module.exports = __webpack_public_path__ + "static/image-03-a@2x-8e82851713236dbee305bd44fff0ca0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/cookpad/image-03-a@2x.jpg
// module id = 347
// module chunks = 3627797113349 20562973939449 33019919093843